import React, { useMemo, useCallback, useEffect, useState } from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import { Loading } from '@components/Gui/Loading';
import AddCallSheetContactCard from '@components/Project/ProjectContacts/AddCallSheetContactCard';

const ProjectViewWrapper = styled.div`
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    h2 {
        font-size: 1.5rem;
        font-weight: bold;
        margin-bottom: 1rem;
    }
`;

const AddCallSheetProjectView = ({ currentProject, onSelectConnection, onChangeView }) => {
    const [projectConnections, setProjectConnections] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleClickConnection = async (projectConnection) => {
        try {
            onSelectConnection(projectConnection);
            onChangeView('form');
        } catch (error) {
            console.error('Get Connection Error => ', error);
        }
    };

    const customerIDAndName = useMemo(() => {
        if (!currentProject) return null;
        if (currentProject.Contact) {
            return {
                ID: currentProject.Contact.ID,
                Name: currentProject.Contact.Name,
            };
        }
        if (currentProject.customerID) {
            return {
                ID: currentProject.customerID,
                Name: getContactName(currentProject.customerID),
            };
        }
        return null;
    }, [currentProject]);

    const eventCustomersID = useMemo(() => {
        if (!currentProject) return [];
        if (currentProject.Events && currentProject.Events.length) {
            const clientIDs = currentProject.Events.map((event) => event.EventClientID);
            //make unique and remove nulls
            if (clientIDs.length) {
                const uniqueClientIDs = [...new Set(clientIDs)].filter((id) => id !== null);
                return uniqueClientIDs;
            }
            return [];
        }
        return [];
    }, [currentProject]);

    // get contacts from current customer, or suggest to search or create a new one
    const getContactConnections = useCallback(async () => {
        if (!customerIDAndName && !eventCustomersID) return;
        setLoading(true);
        const connections = await Axios.post(`/contacts/connections`, [customerIDAndName.ID, ...eventCustomersID]);
        if (connections.length) {
            setProjectConnections(connections);
            // setView('project');
        } else {
            // setView('search');
        }
        setLoading(false);
    }, [customerIDAndName, eventCustomersID]);

    useEffect(() => {
        getContactConnections();
    }, [getContactConnections]);

    if (loading) return <Loading paddingTop="2rem" textBlack />;

    if (projectConnections.length === 0) return <div>No connections found</div>;

    return (
        <ProjectViewWrapper>
            {projectConnections.map((contact) => (
                <AddCallSheetContactCard contact={contact} onClick={handleClickConnection} />
            ))}
        </ProjectViewWrapper>
    );
};

export default AddCallSheetProjectView;
